import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import SingleTicker from 'Components/_charts/singleTicker'
import MultipleTickers from 'Components/_charts/multipleTickers'

import style from './charts.sass'

@inject('store') @observer
class Charts extends Component {
  render() {
    const {algo, loading} = this.props.store.paperTrading
    const tickersCount = typeof algo === 'object' ? algo.all_tickers_count : 0
    return(
      <div styleName='wrapper' className='card'>
        {tickersCount === 1 &&
          <SingleTicker id={this.props.id} store={this.props.store.paperTrading.charts} loading={loading}/>
        }
        {tickersCount > 1 &&
          <MultipleTickers id={this.props.id} store={this.props.store.paperTrading.charts} loading={loading}/>
        }
      </div>
    )
  }
}

export default Charts
